export default [{
    path: '/login',
    name: 'login',
    component: resolve => require(['@/components/user/login.vue'], resolve),
    meta: {
        title: '登录'
    }
}, {
    path: '/register',
    name: 'register',
    component: resolve => require(['@/components/user/register.vue'], resolve),
    meta: {
        title: '注册'
    }
}, {
    path: '/forgetPassword',
    name: 'forgetpassword',
    component: resolve => require(['@/components/user/forgetPassword.vue'], resolve),
    meta: {
        title: '忘记密码'
    }
}]


// WEBPACK FOOTER //
// ./src/router/modules/userRouter.js